import request from "@/utils/request";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;

export function getUserInfo() {
    return request({
        url: `${BASE_API}/oem/api/user`,
        method: "get",
    });
}

export function getPrivilege(params) {
    return request({
        url: `${BASE_API}/oem/api/get_privilege`,
        method: "get",
        params,
    });
}

export function createPrivilege(params) {
    return request({
        url: `${BASE_API}/oem/api/create_privilege`,
        method: "get",
        params,
    });
}